import { useParams, useNavigate } from "react-router-dom";

import CustomModalForm from "@/components/desktop/form/modal/CustomModalForm/CustomModalForm";
import CustomInputText from "@/components/desktop/form/input/input-text/CustomInputText";
import CustomInputSelect from "@/components/desktop/form/input/input-select/CustomInputSelect";
import CustomInputSwitch from "@/components/desktop/form/input/input-switch/CustomInputSwitch";
import CustomFetching from "@/components/desktop/fetching/CustomFetching";

import { useEstatesForm } from "@/hooks/maintainers/estates/useEstatesForm";

const EstatesForm = ({ estatesParents, categories, filters }) => {
	const navigate = useNavigate();
	const { option, slug } = useParams();

	const onClose = () => navigate("/configuracion/campos");

	const { isOpen, modalTitle, isLoadingSave, isLoadingElement, isFetchingElement, formState, setFormState, formErrors, setFormErrors, handleSubmit } =
		useEstatesForm({ option, slug, onClose, filters });

	if (!isOpen) return null;

	const isLoading = isLoadingSave || isLoadingElement || isFetchingElement;

	return (
		<CustomModalForm open={isOpen} onClose={onClose} title={modalTitle} size="md" asForm onSubmit={handleSubmit} isLoading={isLoading}>
			{isLoading ? (
				<CustomFetching center size="lg" />
			) : (
				<>
					<CustomInputText
						label="Nombre"
						name="name"
						value={formState.name}
						onChange={(value) => {
							setFormState((prev) => ({ ...prev, name: value }));
							setFormErrors((prev) => ({ ...prev, name: undefined }));
						}}
						placeholder="Ingrese el nombre"
						required
						col={6}
						error={formErrors.name}
					/>

					<CustomInputSelect
						label="Campo"
						name="estateParentID"
						options={estatesParents ?? []}
						value={formState.estateParentID}
						onChange={(value) => setFormState((prev) => ({ ...prev, estateParentID: value ?? "" }))}
						placeholder="Seleccione campo"
						isClearable
						col={6}
					/>

					<CustomInputSelect
						label="Tipo de bodega"
						name="categoriesID"
						isMulti
						options={categories ?? []}
						value={formState.categoriesID ?? []}
						onChange={(values) => {
							setFormState((prev) => ({ ...prev, categoriesID: values ?? "" }));
						}}
						placeholder="Seleccione tipo(s) de bodega"
						col={6}
						error={formErrors.categoriesID}
					/>

					<CustomInputSwitch
						label="Implementado"
						value={formState.implemented}
						onChange={(value) => setFormState((prev) => ({ ...prev, implemented: value }))}
						col={6}
					/>
				</>
			)}
		</CustomModalForm>
	);
};

export default EstatesForm;
